import { useEffect, useState } from 'react';
import SelectPlace from './SelectPlace';
import SelectThoroughfare from './SelectThroughfare';
import SelectTypeLines from './SelectTypeLines';
import api from '../api/ChoiceReq';

const FlowMeterChoice = ({
    setSelectedFlowMeter, disabled = false   
}) => {
    
    const [flowMeters, setFlowMeters] = useState([]);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [places, setPlaces] = useState([]);
    const [selectedThoroughfare, setSelectedThoroughfare] = useState('');
    const [thoroughfares, setThoroughfares] = useState([]);
    const [selectedTypeLine, setSelectedTypeLine] = useState('');
    const [typeLines, setTypeLines] = useState([]);   
    
    useEffect(() => {
        const fetchFlowMeters = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setFlowMeters(response.data.payload);
                } else {
                    console.error('Error:', response.data.message)
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchFlowMeters();
    }, []);

    useEffect(() => {
        const handlePlaces = () => {
            const newplaces = [...new Set(flowMeters.map(item => item.location_id.place))] 
            return newplaces.map((name, index) => ({id: index+1, name: name}));
            
        }
        if (flowMeters.length > 0) {
            setPlaces(handlePlaces());
        }
    }, [flowMeters])

    useEffect(() => {
        const filterPlaces = () => {
            const newthoroughfare = flowMeters.filter(flowmeter => flowmeter.location_id.place === selectedPlace).map((fl, index) => ({id: index+1, name: fl.location_id.thoroughfare}))
            return newthoroughfare.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setThoroughfares(filterPlaces())
        }
    }, [selectedPlace])

    useEffect(() => {
        const filterPlacesAndThoroughfares = () => {
            const newTypeLines = flowMeters
                                    .filter(flowmeter => flowmeter.location_id.place === selectedPlace && flowmeter.location_id.thoroughfare === selectedThoroughfare)
                                    .map((fl, index) => ({id: index+1, name: fl.location_id.type_line}))
            
            return newTypeLines.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setTypeLines(filterPlacesAndThoroughfares())
        }
    }, [selectedThoroughfare])

    useEffect(() => {
        if (selectedPlace && selectedThoroughfare && selectedTypeLine) {
            // const filteredFlowMeterId = flowMeters
            //                                 .filter(
            //                                     flowmeter => flowmeter.location_id.place === selectedPlace &&
            //                                     flowmeter.location_id.thoroughfare === selectedThoroughfare && 
            //                                     flowmeter.location_id.type_line === selectedTypeLine)
            //                                 .map((flowmeter) => {
            //                                     console.log(`${flowmeter.name} ${flowmeter.id}`);
            //                                     return (flowmeter.id)[0]
            //                                 })
            const filteredFlowMeterId = flowMeters
                                            .filter(
                                                flowmeter => flowmeter.location_id.place === selectedPlace &&
                                                flowmeter.location_id.thoroughfare === selectedThoroughfare && 
                                                flowmeter.location_id.type_line === selectedTypeLine)
                                            .map((flowmeter) => (flowmeter.id))[0]
            setSelectedFlowMeter(filteredFlowMeterId);
        }
    }, [selectedPlace, selectedThoroughfare, selectedTypeLine]);

    return (
        <div className='flow-meter-choicee-card'>
            <h4>Flow Meter</h4>
            <div className="flow-meter-choice-input-group">
                <label
                    htmlFor=''
                    className='bold-label'
                >
                    Place:
                </label>
                <SelectPlace
                    places={places}
                    selectedPlace={selectedPlace}
                    setSelectedPlace={setSelectedPlace}
                    disabled={disabled}
                />
            </div>
            <div className="flow-meter-choice-input-group">
                <label
                    htmlFor=''
                    className='bold-label'
                >
                    Section:
                </label>
                <SelectThoroughfare
                    thoroughfares={thoroughfares}
                    selectedThoroughfare={selectedThoroughfare}
                    setSelectedThoroughfare={setSelectedThoroughfare}
                    disabled={disabled}
                />
            </div>
            <div className="flow-meter-choice-input-group">
                <label
                    htmlFor=''
                    className='bold-label'
                >
                    Type line:
                </label>
                <SelectTypeLines
                    LocationTypeLines={typeLines}
                    selectedlocationTypeLine={selectedTypeLine}
                    setSelectedLocationTypeLine={setSelectedTypeLine}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}

export default FlowMeterChoice;